import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import {
  BulkConfirmModal,
  BulkConfirmIconCircle,
  BulkConfirmTitle,
  BulkConfirmDescription,
  BulkConfirmPrimaryButton,
  BulkConfirmCancelButton,
} from './styles';
import { LABELS, BULK_AUTO_ACCEPT_COPY } from './constants';

export interface BulkAutoAcceptConfirmDialogProps {
  open: boolean;
  enable: boolean;
  affectedCount: number;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const BulkAutoAcceptConfirmDialog: React.FC<BulkAutoAcceptConfirmDialogProps> = ({
  open,
  enable,
  affectedCount,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <BulkConfirmModal
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={false}
      centered
      width={400}
      maskClosable={!loading}
    >
      <BulkConfirmIconCircle>
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </BulkConfirmIconCircle>
      <BulkConfirmTitle>{BULK_AUTO_ACCEPT_COPY.confirmTitle(enable)}</BulkConfirmTitle>
      <BulkConfirmDescription>
        {BULK_AUTO_ACCEPT_COPY.confirmDescription(enable, affectedCount)}
      </BulkConfirmDescription>
      <BulkConfirmPrimaryButton onClick={onConfirm} loading={loading}>
        {BULK_AUTO_ACCEPT_COPY.confirmButtonLabel(enable)}
      </BulkConfirmPrimaryButton>
      <BulkConfirmCancelButton onClick={onCancel} disabled={loading}>
        {LABELS.CANCEL}
      </BulkConfirmCancelButton>
    </BulkConfirmModal>
  );
};

export default React.memo(BulkAutoAcceptConfirmDialog);
